import { render, staticRenderFns } from "./SignupConfirm.vue?vue&type=template&id=350f8e44"
import script from "./SignupConfirm.vue?vue&type=script&lang=js"
export * from "./SignupConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports